// common business logic related util methods
import axios from "axios";
import { baseUrl } from "../config/config";
import { clearAuthStorage } from "../utils/authStorage";

axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.withCredentials = true;

/** Identifies partner-react-app for the backend (see X-Veekrypt-App). */
const DEFAULT_APP_HEADERS = { "X-Veekrypt-App": "partner" };

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  const reqObj = {
    method,
    url: baseUrl + path,
    headers: { ...DEFAULT_APP_HEADERS, ...headers },
  };

  reqObj.params = queryParams;

  if (method === "POST") {
    reqObj.data = postData;
  }
  if (method === "PUT") {
    reqObj.data = postData;
  }
  if (method === "DELETE") {
    reqObj.data = postData;
  }

  let results;
  if (postData instanceof FormData) {
    reqObj.headers["Content-Type"] = "multipart/form-data";
  }

  try {
    results = await axios(reqObj);

    return results.data;
  } catch (error) {
    const statusCode = error?.response?.status;
    if (statusCode === 401) {
      clearAuthStorage();
      window.location.reload();
    }

    const responseData = error?.response?.data;
    const fallbackMessage =
      error?.message || "Request failed. Please try again later.";

    return {
      code: statusCode || 0,
      message: responseData?.message || fallbackMessage,
    };
  }
}
